import classnames from 'classnames';
import ECSEditorContext from 'contexts/ECSEditorContext';
import { EditorTools } from 'editor/components/Tool';
import toolbarArrow from 'images/toolbar-arrow.svg';
import toolbarCloud from 'images/toolbar-cloud.svg';
import toolbarLine from 'images/toolbar-line.svg';
import toolbarPointer from 'images/toolbar-pointer.svg';
import toolbarText from 'images/toolbar-text.svg';
import React, { FC, useContext } from 'react';
import './toolbar.css';

const Toolbar: FC = () => {
  const { tool: toolComp } = useContext(ECSEditorContext);
  const currentTool = toolComp ? toolComp.tool : EditorTools.Pointer;

  function handleToolChange(nextTool: EditorTools): void {
    if (toolComp) toolComp.tool = nextTool;
  }

  return (
    <div className="toolbar markup-tools">
      <div
        className={classnames('tool', {
          selected: currentTool === EditorTools.Pointer,
        })}
        onClick={(): void => handleToolChange(EditorTools.Pointer)}
      >
        <img src={toolbarPointer} alt="toolbar-pointer" />
      </div>
      <div
        className={classnames('tool', {
          selected: currentTool === EditorTools.DrawRectangle,
        })}
        onClick={(): void => handleToolChange(EditorTools.DrawRectangle)}
      >
        <img src={toolbarCloud} alt="toolbar-cloud" />
      </div>
      <div
        className={classnames('tool', {
          selected: currentTool === EditorTools.DrawLine,
        })}
        onClick={(): void => handleToolChange(EditorTools.DrawLine)}
      >
        <img src={toolbarLine} alt="toolbar-cloud" />
      </div>
      <div
        className={classnames('tool', {
          selected: currentTool === EditorTools.DrawArrow,
        })}
        onClick={(): void => handleToolChange(EditorTools.DrawArrow)}
      >
        <img src={toolbarArrow} alt="toolbar-cloud" />
      </div>
      <div
        className={classnames('tool', {
          selected: currentTool === EditorTools.DrawText,
        })}
        onClick={(): void => handleToolChange(EditorTools.DrawText)}
      >
        <img src={toolbarText} alt="toolbar-cloud" />
      </div>
    </div>
  );
};

export default Toolbar;
